// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  NO_COUNTRY_FOUND: 'No country found for "{query}"',
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_COUNTRY_FIELD',
  MESSAGES
)
